import React from 'react';
import { MapPin, Phone, MessageCircle, Clock, Mail } from 'lucide-react';

/**
 * Seção "Contato + Mapa" — como no mockup GoldenPax, aparece antes do footer.
 * Layout split: bloco com contatos à esquerda + mapa embed à direita.
 */
const MapaContatoSection = () => (
  <section className="py-16 bg-white" data-testid="mapa-contato-section">
    <div className="container mx-auto px-4">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#2E6B35] mb-3">
            Onde Estamos
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Atendimento em Campo Grande, RJ e toda a região metropolitana do Rio de Janeiro.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
          {/* Bloco de contato — fundo verde claro sutil */}
          <div className="bg-[#E0F2E3] rounded-3xl p-8 md:p-10 shadow-md">
            <h3 className="font-bold text-2xl text-[#2E6B35] mb-6">Fale com a Golden Pax Rio</h3>
            <ul className="space-y-5 text-gray-800">
              <li className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center flex-shrink-0 shadow-sm">
                  <Phone className="w-5 h-5 text-[#2E6B35]" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-wider text-[#2E6B35] mb-0.5">Telefone 24h</div>
                  <a href="tel:972300064" className="font-bold text-lg text-[#2E6B35] hover:text-[#245629]">
                    (021) 97230-0064
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center flex-shrink-0 shadow-sm">
                  <MessageCircle className="w-5 h-5 text-[#67A871]" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-wider text-[#2E6B35] mb-0.5">WhatsApp</div>
                  <a
                    href="https://wa.me/5521972300064"
                    className="font-bold text-lg text-[#2E6B35] hover:text-[#245629]"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    (021) 97230-0064
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center flex-shrink-0 shadow-sm">
                  <MapPin className="w-5 h-5 text-[#2E6B35]" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-wider text-[#2E6B35] mb-0.5">Localização</div>
                  <p className="font-semibold text-gray-900">Campo Grande, Rio de Janeiro - RJ</p>
                  <p className="text-sm text-gray-700">Atendemos toda a Zona Oeste e Baixada Fluminense</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center flex-shrink-0 shadow-sm">
                  <Clock className="w-5 h-5 text-[#2E6B35]" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-wider text-[#2E6B35] mb-0.5">Horário</div>
                  <p className="font-semibold text-gray-900">24 horas, 7 dias por semana</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center flex-shrink-0 shadow-sm">
                  <Mail className="w-5 h-5 text-[#2E6B35]" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-wider text-[#2E6B35] mb-0.5">E-mail</div>
                  <a href="mailto:contato@funerariagoldenpaxrio.com" className="font-semibold text-gray-900 hover:text-[#2E6B35] break-all">
                    contato@funerariagoldenpaxrio.com
                  </a>
                </div>
              </li>
            </ul>
          </div>

          {/* Mapa Google embed — Campo Grande, RJ */}
          <div className="rounded-3xl overflow-hidden shadow-lg border-4 border-[#E0F2E3] min-h-[400px]">
            <iframe
              title="Localização Funerária Golden Pax Rio - Campo Grande RJ"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3676.7856!2d-43.5614!3d-22.9046!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sCampo%20Grande%2C%20Rio%20de%20Janeiro%20-%20RJ!5e0!3m2!1spt-BR!2sbr!4v1707000000000"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: 400 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              data-testid="mapa-embed"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default MapaContatoSection;
